

export const LOAD_MORE_ORDERS_OF_USER='LOAD_MORE_ORDERS_OF_USER'
export const LOAD_MORE_ORDERS_OF_USER_SUCCESS= 'LOAD_MORE_ORDERS_OF_USER_SUCCESS'
export const LOAD_MORE_ORDERS_OF_USER_ERROR='LOAD_MORE_ORDERS_OF_USER_ERROR'

export const LoadMoreOrdersOfUser= (data) => ({
    type: LOAD_MORE_ORDERS_OF_USER,
    payload: data
});
